import * as React from 'react';
import './BrowsingHistoryProducts.scss';
import BrowsingHistoryServiceInstance from '../../services/products/BrowsingHistoryService';
import ProductModel from 'src/model/product.model';
import listService from 'src/services/lists/ListsService';
import { ifLoggedIn, goToPartDetail, goToHome } from 'src/utils/navigation';
import ProductCard from '../ProductCard/ProductCard';
import Breadcrumbs from '../common/Breadcrumbs';
import i18n from 'src/translation/i18n';
import backArrow from '../../assets/back-arrow';
import { analyticsListNames } from 'src/analytics/constant';

interface IBrowsingHistoryProductsProps {
  handlePageChange(event: any): any;
  fireProductImpressionEvent(data: any): void;
  fireProductClickEvent(data: any): void;
}

interface IBrowsingHistoryProductsState {
  isLoading: boolean;
  isFavoriteLoading: boolean;
  selectedFavoriteItem: string;
  products: ProductModel[];
  activePage: number;
}

class BrowsingHistoryProducts extends React.Component<
  IBrowsingHistoryProductsProps,
  IBrowsingHistoryProductsState
> {
  constructor(props: any) {
    super(props);
    this.state = {
      isLoading: true,
      isFavoriteLoading: true,
      selectedFavoriteItem: '',
      products: [],
      activePage: 1
    };
  }

  public handleBuyNow = (productId: string) => {
    const productClicked = this.state.products.find(
      product =>
        `${product.manufacturerCode}  ${product.productNumber}` === productId
    );
    productClicked['position'] =
      this.state.products.indexOf(productClicked) + 1;
    this.props.fireProductClickEvent({
      product: productClicked,
      list: analyticsListNames.BROWSING_HISTORY_VIEW_ALL
    });
    ifLoggedIn(() => goToPartDetail(productId));
  };

  private getProducts = () => {
    BrowsingHistoryServiceInstance.getProducts().then(res => {
      this.setState({
        isLoading: false,
        isFavoriteLoading: false,
        selectedFavoriteItem:'',
        products: res
      });
      this.props.fireProductImpressionEvent({
        products: res,
        list: analyticsListNames.BROWSING_HISTORY_VIEW_ALL
      });
    });
  };

  private handleToggleFavorite = (
    name: string,
    mfc: string,
    favorite: boolean,
    favoriteId: number
  ) => {
    if (favorite) {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); // Start loading
      listService.deleteItem(favoriteId).then(res => this.getProducts());
    } else {
      this.setState({ isFavoriteLoading: true,selectedFavoriteItem: name }); 
      listService
        .addItem('favorites', name, mfc)
        .then(res => this.getProducts())
        .catch(error => {
          console.error("Failed to add item:", error);
          this.setState({ isFavoriteLoading: false }); // End loading in case of error
        });
    }
  };

  private reloadList = () => {
    this.getProducts();
  };

  public componentDidMount() {
    this.getProducts();
  }

  public render() {
    return (
      <div>
        <div className="rp-view-all-list-container">
          <img
            className="rp-back-arrow-view-all"
            src={backArrow}
            alt="RP-Back-To-Page"
            onClick={goToHome}
          />
          <Breadcrumbs>
            {i18n.t('common.home')} / {i18n.t('common.browsingHistory')}
          </Breadcrumbs>
        </div>
        <div className="row no-gutters rp-browsing-products-section">
          {this.state.products.length > 0 &&
            this.state.products.map((product, index) => (
              <ProductCard
                key={index}
                part={product}
                id={product.productNumber}
                name={product.productNumber}
                mfc={product.manufacturerCode}
                description={product.description}
                price={product.partnerPrice}
                msrp={product.retailPrice}
                image={product.imageUrls !== null ? product.imageUrls[0] : ''}
                handleOnClicBuyNow={this.handleBuyNow}
                handleToggleFavorite={this.handleToggleFavorite}
                inStock={product.inStock}
                isFavoriteLoading = {this.state.isFavoriteLoading}
                selectedFavoriteItem = {this.state.selectedFavoriteItem}
                favorite={product.favorite}
                favoriteId={product.idFavoriteItem}
                deal={!!product.discountInfo}
                state={product.state}
                stateDescription={product.stateDescription}
                reloadPart={this.reloadList}
              />
            ))}
        </div>
      </div>
    );
  }
}
export default BrowsingHistoryProducts;
